import React from 'react';
import { Tag, TagLabel, Tooltip } from '@chakra-ui/react';
import './StatusBadge.scss';

export type QueueStatus =
  | 'healthy'
  | 'at-risk'
  | 'critical'
  | 'needs-attention'
  | 'superstar'
  | 'overdue'
  | 'due-soon';

const STATUS_LABELS: Record<QueueStatus, string> = {
  healthy: 'Healthy',
  'at-risk': 'At Risk',
  critical: 'Critical',
  'needs-attention': 'Needs Attention',
  superstar: 'Superstar',
  overdue: 'Overdue',
  'due-soon': 'Due Soon',
};

const STATUS_TOOLTIPS: Record<QueueStatus, string> = {
  healthy: 'This queue is meeting all targets',
  'at-risk': 'This queue is at risk of missing targets',
  critical: 'This queue is critically behind on targets',
  'needs-attention': 'This queue requires immediate attention',
  superstar: 'This queue is exceeding all targets',
  overdue: 'This project is past its target completion date',
  'due-soon': 'This project is due within 3 days',
};

export interface StatusBadgeProps {
  status: QueueStatus;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  className = ''
}) => {
  return (
    <Tooltip label={STATUS_TOOLTIPS[status]} placement="top" hasArrow>
      <Tag
        variant="unstyled"
        className={`cmx-status-badge cmx-status-badge--${status} ${className}`.trim()}
        data-testid="status-badge"
      >
        <TagLabel>{STATUS_LABELS[status]}</TagLabel>
      </Tag>
    </Tooltip>
  );
};

StatusBadge.displayName = 'StatusBadge';
export default StatusBadge;
